import { queryOptions } from '@tanstack/react-query';

import { useLocalizationStore } from '$/components/core/Localization/hooks/useLocalizationStore';
import { STANDARD_STALE_TIME } from '$/services/constants';
import {
  getAllInspirations,
  getInspirationById,
} from '$/services/usecases/inspirations';

export const allInspirationsQuery = () => {
  const { country } = useLocalizationStore.getState();

  return queryOptions({
    queryKey: ['inspirations', country],
    queryFn: ({ signal }) => getAllInspirations(signal, country),
    staleTime: STANDARD_STALE_TIME,
  });
};

export const inspirationQuery = (id: string, ignoreMissingMaterials = false) =>
  queryOptions({
    queryKey: ['inspiration', id, ignoreMissingMaterials],
    queryFn: ({ signal }) =>
      getInspirationById(id, signal, ignoreMissingMaterials),
    staleTime: STANDARD_STALE_TIME,
  });
